import format from '../plugins/baseFormat';
export default class DriverReport {
  constructor (initialData = {},) {
    const {
      driver_id,
      full_name,
      orders_count,
      transfer_value,
      total_value,
      // status,
      // benefits,
    } = initialData;

    (this.driver_id = driver_id),
    (this.full_name = full_name),
    (this.checked = false),
    (this.orders_count = orders_count),
    (this.transfer_value = transfer_value),
    (this.total_value = total_value);
    // (this.status = status),
    // (this.benefits = benefits);
  }

  get formatted_status () {
    const aliases = {
      WAITING_APPROVAL: 'Aguardando aprovação',
      PENDING: 'Pendente',
      READY_FOR_TRAINING: 'Apto para treinamento',
      TRAINING: 'Em treinamento',
      READY_TO_DELIVER: 'Apto para realizar entrega',
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      BLOCKED: 'Bloqueado',
      DISAPPROVED: 'Reprovado',
    };

    return aliases[this.status] || 'Desconhecido';
  }

  get formatted_total_value () {
    if (this.total_value === null || this.total_value === undefined) {return '-';}
    return format.money(this.total_value,);
  }

  get formatted_transfer_value () {
    if (this.transfer_value === null || this.transfer_value === undefined) {return '-';}
    return format.money(this.transfer_value,);
  }

  // get formatted_benefits () {
  //   if (!this.benefits.length) return 'Nenhum';
  //   let benefitsString = '';
  //   this.benefits.forEach(benefit => {
  //     benefitsString += {
  //       'NO_BENEFITS': 'Nenhum ',
  //     }[benefit]
  //   });
  //   return benefitsString;
  // }

}
